
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type NotificationSoundState = {
  enabled: boolean;
  volume: number;
  setEnabled: (enabled: boolean) => void;
  setVolume: (volume: number) => void;
};

export const useNotificationSoundStore = create<NotificationSoundState>()(
  persist(
    (set) => ({
      enabled: true,
      volume: 0.5,
      setEnabled: (enabled) => set({ enabled }),
      setVolume: (volume) => set({ volume: Math.min(1, Math.max(0, volume)) }),
    }),
    { name: 'pridex-notification-sound' }
  )
);
